module.exports = __webpack_public_path__ + "img/FullCover_Chi3.7a5e88f9.jpg";